export const AUTHENTICATE_PAGE = '/';
export const LOGOUT_PAGE = '/logout';
export const DOCUMENTS_PAGE = '/documents';
export const UPLOAD_PAGE = '/upload';
export const RELEASE_PAGE = '/release';
export const SETTINGS_PAGE = '/settings';
export const DASHBOARD_PAGE = '/dashboard';
